import React from "react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_e8cdac99-854f-4507-b03c-58ec290ec5ef/artifacts/mr8mjaed_Dr%20Tayyeb%20logo%20%281%29.png";

export default function Logo({ size = 40, withText = false, dark = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="Dr Tayyeb's Dental & Maxillofacial Centre"
        width={size}
        height={size}
        className="rounded-full object-cover"
        style={{ width: size, height: size }}
      />
      {withText && (
        <div className="leading-tight">
          <div className={`font-black text-base tracking-tight ${dark ? "text-white" : "text-zinc-900"}`}>
            DR TAYYEB&apos;S
          </div>
          <div className={`text-[10px] uppercase tracking-[0.2em] ${dark ? "text-zinc-400" : "text-zinc-500"}`}>
            Dental &amp; Maxillofacial · Unchwa, GKP
          </div>
        </div>
      )}
    </div>
  );
}
